import config from 'config';
import Utils  from 'Utils';
import 'heightline';


/**
 * HeightLine class
 */
class HeightLine {
  /**
   * [constructor description]
   * @return {[type]} [description]
   */
  constructor() {
    this.$el = $('.js-heightLine');

    this.init();
  }

  /**
   * HeightLineを実行
   * @return {[type]} [description]
   */
  init() {
    this.$el.each((i, v) => {
      $(v).find('.js-heightLine-item').heightLine();
    });
  }
}

export default HeightLine;



// WEBPACK FOOTER //
// ./src/js/modules/HeightLine.js